var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1629.17 1629.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Beams_24",
    "data-name": "Beams 24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "814.58 0 793.37 0 814.58 814.58 835.8 0 814.58 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.29 109.13 388.92 119.74 814.58 814.58 425.66 98.53 407.29 109.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.13 407.29 98.53 425.66 814.58 814.58 119.74 388.92 109.13 407.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 814.58 0 835.8 814.58 814.58 0 793.37 0 814.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.13 1221.88 119.74 1240.25 814.58 814.58 98.53 1203.5 109.13 1221.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.29 1520.03 425.66 1530.64 814.58 814.58 388.92 1509.43 407.29 1520.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "814.58 1629.17 835.8 1629.17 814.58 814.58 793.37 1629.17 814.58 1629.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1221.88 1520.03 1240.25 1509.43 814.58 814.58 1203.5 1530.64 1221.88 1520.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1520.03 1221.88 1530.64 1203.5 814.58 814.58 1509.43 1240.25 1520.03 1221.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "814.58 814.58 1629.17 835.8 1629.17 814.58 1629.17 793.37 814.58 814.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1520.03 407.29 1509.43 388.92 814.58 814.58 1530.64 425.66 1520.03 407.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1221.88 109.13 1203.5 98.53 814.58 814.58 1240.25 119.74 1221.88 109.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1250.77 378.4 1239.41 367.04 814.58 814.58 1262.13 389.75 1250.77 378.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "974.24 218.74 958.72 214.58 814.58 814.58 989.75 222.9 974.24 218.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "654.93 218.74 639.41 222.9 814.58 814.58 670.45 214.58 654.93 218.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.4 378.4 367.04 389.75 814.58 814.58 389.75 367.04 378.4 378.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.74 654.93 214.58 670.45 814.58 814.58 222.9 639.41 218.74 654.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.74 974.24 222.9 989.75 814.58 814.58 214.58 958.72 218.74 974.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.4 1250.77 389.75 1262.13 814.58 814.58 367.04 1239.41 378.4 1250.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "654.93 1410.43 670.45 1414.58 814.58 814.58 639.41 1406.27 654.93 1410.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "974.24 1410.43 989.75 1406.27 814.58 814.58 958.72 1414.58 974.24 1410.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1250.77 1250.77 1262.13 1239.41 814.58 814.58 1239.41 1262.13 1250.77 1250.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1406.27 989.75 1410.43 974.24 1414.58 958.72 814.58 814.58 1406.27 989.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1410.43 654.93 1406.27 639.41 814.58 814.58 1414.58 670.45 1410.43 654.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "814.58 0 780.64 0 814.58 814.58 848.52 0 814.58 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "814.58 814.58 1629.17 848.52 1629.17 814.58 1629.17 780.64 814.58 814.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "814.58 1629.17 848.52 1629.17 814.58 814.58 780.64 1629.17 814.58 1629.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 814.58 0 848.52 814.58 814.58 0 780.64 0 814.58"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShine);
export default __webpack_public_path__ + "static/media/shine.e587f550578e7be0d1998fde9f3576ce.svg";
export { ForwardRef as ReactComponent };